export const NAMESPACE = '@sail/observability';
